export default __webpack_public_path__ + "static/media/gallery_09.2aed6fdb.jpg";